import { Route, Routes } from "react-router-dom";
import ViewImage from "../Components/ImageComponent/ViewImg";
import { Privaterouter } from "../Components/Privaterouter/Privaterouter";
import { SingleIssue } from "../Components/RequestSupportComponent/SingleIssue/SingleIssue";
import SideNavBar from "../Components/SideNavbar/SideNavBar";
import AccountingGroup from "../Pages/AccountGroup/AccountGroup";
import AdminRequestSupport from "../Pages/AdminRequestSupport/AdminRequestSupport";
import AlertManagemenet from "../Pages/AlertManagement/AlertManagement";
import AlertTemplate from "../Pages/AlertTemplate/AlertTemplate";
import AreaMaster from "../Pages/AreaMaster/AreaMaster";
import AssetAccount from "../Pages/AssetAccount/AssetAccount";
import BalanceSheet from "../Pages/BalanceSheet/BalanceSheet";
import BankAccount from "../Pages/BankAccount/BankAccount";
import BankPayment from "../Pages/BankPayment/BankPayment";
import BankReceipt from "../Pages/BankReceipt/BankReceipt";
import AgainstReferences from "../Pages/BillByBill/Receivable/AgainstReferences";
import NewReferences from "../Pages/BillByBill/Receivable/NewReference";
import ReceivableBillByBill from "../Pages/BillByBill/Receivable/ReceivableBillByBill";
import BookingPage from "../Pages/BookingPage/BookingPage";
import Branch from "../Pages/Branch/Branch";
import CSUsers from "../Pages/CSUsers/CSUsers";
import CashReceipt from "../Pages/CashReciept/CashReciept";
import ChargeMaster from "../Pages/ChargeMaster/CharegeMaster";
import Cityes from "../Pages/Cities/Cities";
import ClaimsPage from "../Pages/Claims/Claims";
import Company from "../Pages/Company/Company";
import ConnectionCenter from "../Pages/ConnectionCenter/ConnectionCenter";
import ConnectionPlanning from "../Pages/ConnectionPlanning/ConnectionPlanning";
import DestinationInward from "../Pages/DestinationInward/DestinationInward";
import ConsignmentNote from "../Pages/ConsignmentNote/ConsignmentNote";
import ConsignorPart from "../Pages/ConsignorPart/ConsignorPart";
import Contra from "../Pages/Contra/Contra";
import CountryMaster from "../Pages/CountryMaster/CountryMaster";
import CreditNote from "../Pages/CreditNote/CreditNote";
import CustomerAccount from "../Pages/CustomerAccount/CustomerAccount";
import CustomerSideLogs from "../Pages/CustomerSideLogs/CustomerSideLogs";
import Dashboard from "../Pages/Dashboard/Dashboard";
import DebitNote from "../Pages/DebitNote/DebitNote";
import DeliveryPlanning from "../Pages/DeliveryPlanning/DeliveryPlanning";
import DistrictMaster from "../Pages/DistrictMaster/DistrictMaster";
import DriverAccount from "../Pages/DriverAccount/DriverAccount";
import EmtUserLogs from "../Pages/EmtUserLogs/EmtUserLogs";
import ErpUserLogs from "../Pages/EmtUserLogs/ErpUserLogs";
import EventMaster from "../Pages/EventMaster/EventMaster";
import FieldsMaster from "../Pages/FieldsMaster/FieldsMaster";
import FlightMaster from "../Pages/FlightMaster/FlightMaster";
import FreightBill from "../Pages/FreightBill/FreightBill";
import GodownMaster from "../Pages/GodownMaster/GodownMaster";
import InwardConnectionCenter from "../Pages/InwardConnectionCenter/InwardConnectionCenter";
import JournalVoucher from "../Pages/JournalVoucher/JournalVoucher";
import LRTypeMaster from "../Pages/LRTypeMaster/LRTypeMaster";
import Ledger from "../Pages/Ledger/Ledger";
import License from "../Pages/License/License";
import { LicenseRigths } from "../Pages/LicenseRights/LicenseRights";
import LiveUsers from "../Pages/LiveUsers/LiveUsers";
import LoadEntry from "../Pages/LoadEntry/LoadEntry";
import Login from "../Pages/Login/Login";
import MaterialCategory from "../Pages/MaterialCategory/MaterialCategory";
import MenuMaster from "../Pages/MenuMaster/MenuMaster";
import ModalTypeMaster from "../Pages/ModelTypeMaster/ModelTypeMaster";
import LoadBoard from "../Pages/MyLoads/MyLoads";
import MyShipment from "../Pages/MyShipments/MyShipment";
import NewFinancialYear from "../Pages/NewFinincialYear/NewFinancialYear";
import NominalAccount from "../Pages/NominalAccount/NominalAccount";
import POD from "../Pages/POD_Management/POD";
import PackagingMaster from "../Pages/PackagingMaster/PackagingMaster";
import PageFallback from "../Pages/PageFallback/PageFallback";
import PageMaster from "../Pages/PageMaster/PageMaster";
import PartMaster from "../Pages/PartMaster/PartMaster";
import { Payment } from "../Pages/Payment/Payment";
import PaymentTermsMaster from "../Pages/PaymentTermsMaster/PaymentTermsMaster";
import PickUpMemo from "../Pages/PickUpMemo/PickupMemo";
import PinCodeMaster from "../Pages/PinCodeMaster/PinCodeMaster";
import PrivateGroup from "../Pages/PrivateGroup/PrivateGroup";
import PrivateNetwork from "../Pages/PrivateNetwork/PrivateNetwork";
import ProductMaster from "../Pages/ProductMaster/ProductMaster";
import PurchaseBill from "../Pages/PurchaseBill/PurchaseBill";
import ReceiptInfo from "../Pages/ReciptInfo/ReceiptInfo";
import RequestApproval from "../Pages/RequestApproval/RequestApproval";
import { ClosedIssues } from "../Pages/RequestSupport/AllIssues/ClosedIssues";
import { HoldIssues } from "../Pages/RequestSupport/AllIssues/HoldIssues";
import { OpenIssues } from "../Pages/RequestSupport/AllIssues/OpenIssues";
import { UnReadIssues } from "../Pages/RequestSupport/AllIssues/UnreadIssues";
import { RequestSupport } from "../Pages/RequestSupport/RequestSupport";
import HSNMaster from "../Pages/SalesBillSetup/HSNMaster/HSNMaster";
import LinkSaleExpenses from "../Pages/SalesBillSetup/LinkSaleExpenses/LinkSaleExpenses";
import States from "../Pages/States/States";
import StatusBoard from "../Pages/StatusBoard/StatusBoard";
import SubMenuMaster from "../Pages/SubMenuMaster/SubMenuMaster";
import THC from "../Pages/THC/THC";
import TruckPost from "../Pages/TruckPost/TruckPost";
import UserEntry from "../Pages/UserEntry/UserEntry";
import ErrorLogs from "../Pages/UserLogs/ErrorLogs";
import UserLogs from "../Pages/UserLogs/UserLogs";
import UserPaymentTermsManagement from "../Pages/UserPaymentTermsManagement/UserPaymentTermsManagement";
import { UserRights } from "../Pages/UserRights/UserRights";
import UserRole from "../Pages/UserRoles/UserRoles";
import UtilityPage from "../Pages/UtilityPage/UtilityPage";
import VehicleAccount from "../Pages/VehicleAccount/VehicleAccount";
import VehicleCategoryMaster from "../Pages/VehicleCategoryMaster/VehicleCategoryMaster";
import VehicleLength from "../Pages/VehicleLengthMaster/VehicleLength";
import VehicleManagement from "../Pages/VehicleManagement/VehicleManagement";
import VehicleOwnerAccount from "../Pages/VehicleOwnerAccount/VehicleOwnerAccount";
import VehicleTypeMaster from "../Pages/VehicleTypeMaster/VehicleTypeMaster";
import VendorAccount from "../Pages/VendorAccount/VendorAccount";
import ZoneMaster from "../Pages/ZoneMaster/ZoneMaster";
import Layout from "../Templets/Layout/Layout";
import UploadForm from "./Testfile";
// import KanbanBoard from "../Pages/StatusBoard/KanbanBoard";
// import { AddKYCVerification } from "../Components/FormComponents";
import AddClaimSale from "../Components/FormComponents/AddClaimSales/AddClaimSale";
import AddTollAndFuelCalculator from "../Components/FormComponents/AddTollAndFuelCalculator/AddTollAndFuelCalculator";
import ReportSetup from "../Components/FormComponents/ReportSetup/ReportSetup";
import Todo from "../Components/ToDo/Todo";
import AccLoadPost from "../Pages/AccLoadPost/AccLoadPost";
import TrailBalance from "../Pages/AccountBalances/TrailBalance";
import TrailOpeningBalances from "../Pages/AccountBalances/TrailOpeningBalances";
import SingleAccountCheck from "../Pages/AccountingCheck/SingleAccountCheck";
import AccountingChecksPage from "../Pages/AccountingChecksPages/AccountingChecksPage";
import AccountChecks from "../Pages/AccountingChecksPages/ChecksPages/AccountChecks";
import MonthlyAccountBalanceCheck from "../Pages/AccountingChecksPages/ChecksPages/MonthlyAccountBalanceCheck";
import AllReferences from "../Pages/AllReferences/AllReferences";
import AppDetails from "../Pages/AppDetails/AppDetails";
import BookingBroker from "../Pages/BookingBroker/BookingBroker";
import CNLocationReport from "../Pages/CNLocationReport/CNLocationReport";
import CNPickupUpdation from "../Pages/CNPickupUpdation/CNPickupUpdation";
import CallReport from "../Pages/CallReport/CallReport";
import CashPayment from "../Pages/CashPayment/CashPayment";
import ClaimSales from "../Pages/ClaimSales/ClaimSales";
import Compliances from "../Pages/Compliances/Compliances";
import ConsignmentNoteRagister from "../Pages/ConsignmentNoteRagister/ConsignmentNoteRagister";
import ContactPersonMaster from "../Pages/ContactPersonMaster/ContactPersonMaster";
import EMTDriverAccount from "../Pages/EMT_Driver_Account/EmtDriverAccount";
import ERPAddressBookMaster from "../Pages/ERPAddressBookMaster/ERPAddressBookMaster";
import EmployeeAccount from "../Pages/EmployeeAccount/EmployeeAccount";
import EmtAccounts from "../Pages/EmtAccounts/EmtAccounts";
import EmtLoadDetails from "../Pages/EmtLoadDetails/EmtLoadDetails";
import EmtMarketRate from "../Pages/EmtMarketRate/EmtMarketRate";
import EmtPlans from "../Pages/EmtPlans/EmtPlans";
import EmtReports from "../Pages/EmtReports/EmtReports";
import EmtVideoTutorial from "../Pages/EmtVideoTutorial/EmtVideoTutorial";
import FTLCNDelivery from "../Pages/FTLCNDelivery/FTLCNDelivery";
import FTLConsignmentNote from "../Pages/FTLConsignmentNote/FTLConsignmentNote";
import AddFieldMaster from "../Pages/FieldsMaster/AddFieldMaster";
import Folder from "../Pages/Folder/Folder";
import FormKeyMaster from "../Pages/FormKey/FormKeyMaster.jsx";
import GeneralAccount from "../Pages/GeneralAccount/GeneralAccount";
import FormSections from "../Pages/InputFieldSetup/FormSections";
import InputFields from "../Pages/InputFieldSetup/InputFields";
import InvoiceFormat from "../Pages/InvoiceFormat/InvoiceFormat";
import KYCVerification from "../Pages/KYCVerification/KYCVerification";
import LMSProcess from "../Pages/LMSProcess/LMSProcess";
import LMSSalesBill from "../Pages/LMSSalesBill/LMSSalesBill";
import { AccountVoucher } from "../Pages/Ledger/AccountVoucher";
import { MonthlyAccountLedger } from "../Pages/Ledger/MonthlyLedger.jsx";
import LoadPostDetails from "../Pages/LoadPostDetails/LoadPostDetails";
import LoadPostErp from "../Pages/LoadPostErp/LoadPostErp";
import LrBook from "../Pages/LrBook/LrBook";
import LrCenter from "../Pages/LrCenter/LrCenter";
import MyShipmentTracking from "../Pages/MyShipmentTrackings/MyShpmentTrackings";
import MyTruckPost from "../Pages/MyTruckPost/MyTruckPost";
import MyVehicleManagement from "../Pages/MyVehicleManagent/MyVehicleMagent";
import OperationsManagement from "../Pages/OperationsManagement/OperationsManagement";
import OrionAppUsers from "../Pages/OrionAppUsers/OrionAppUsers";
import PageActivityDetails from "../Pages/PageActivityDetails/PageActivityDetails";
import PaymentGateway from "../Pages/PaymentGateway/PaymentGateway";
import PlaceMaster from "../Pages/PlaceMaster/PlaceMaster";
import PrintLayout from "../Pages/PrintLayout/PrintLayout";
import ProfitAndLoss from "../Pages/ProfitAndLoss/ProfitAndLoss";
import { AddKYCVerification } from "../Components/FormComponents";
import PayableBillByBill from "../Pages/BillByBill/Payable/PayableBillByBill";
import PendingBillForLR from "../Pages/PendingBillForLR/PendingBillForLR";
import PriceList from "../Pages/PriceList/PriceList";
import SalesBill from "../Pages/SalesBill/SalesBill";
import TCS from "../Pages/SalesBillSetup/TDSAndTCS/Tcs";
import TDS from "../Pages/SalesBillSetup/TDSAndTCS/Tds";
import Tax from "../Pages/SalesBillSetup/Tax/Tax";
import TaxGroup from "../Pages/SalesBillSetup/TaxGroup/TaxGroup";
import SalesReturn from "../Pages/SalesReturn/SalesReturn";
import ServiceTypeMaster from "../Pages/ServiceTypeMaster/ServiceTypeMaster";
import ShipmentTrackBoard from "../Pages/ShipmentTrack/ShipmentTrackBoard";
import Board from "../Pages/StatusBoard/Board";
import StockGroup from "../Pages/StockGroup/StockGroup";
import StockItem from "../Pages/StockItem/StockItem";
import SalesReportVoucherEntries from "../Pages/StockItemSalesReport/SalesReportVoucherEntries";
import StockItemSalesReportForPurchaseBill from "../Pages/StockItemSalesReport/StockItemSalesReportForPurchaseBill";
import StockItemSalesReportForSalesBill from "../Pages/StockItemSalesReport/StockItemSalesReportForSalesBill";
import StockReport from "../Pages/StockReport/StockReport";
import TMSLoadBoard from "../Pages/TMSLoadBoard/TMSLoadBoard";
import TMSTruckPost from "../Pages/TMSTruckPost/TMSTruckPost";
import TableColumnManagement from "../Pages/TableColumnManagement/TableColumnManagement";
import TableKey from "../Pages/TableKey/TableKey";
import Tax_Percentage from "../Pages/TaxPercentage/TaxPercentage";
import Taxes from "../Pages/Taxes/Taxes";
import TrackDetails from "../Pages/TrackDetails/TrackDetails";
import TradingReport from "../Pages/TradingReport/TradingReport";
import TrainMaster from "../Pages/TrainMaster/TrainMaster";
import TransactionsCheck from "../Pages/TransactionsCheck/TransactionsCheck";
import TruckPostDetails from "../Pages/TruckPostDetails/TruckPostDetails";
import VesselMaster from "../Pages/VesselMaster/VesselMaster";
import VoucherSeries from "../Pages/VoucherSeries/VoucherSeries";
import WarehouseMaster from "../Pages/WarehouseMaster/WarehouseMaster";
import DeliveryConfirmation from "../Pages/DeliveryConfirmation/DeliveryConfirmation";
import ConnectionStatusUpdate from "../Pages/ConnectionStatusUpdate/ConnectionStatusUpdate";

const AllRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="*" element={<PageFallback />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/Load"
          element={
            <Privaterouter>
              <Layout>
                <LoadEntry />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/VendorAccount"
          element={
            <Privaterouter>
              <Layout>
                <VendorAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CustomerAccount"
          element={
            <Privaterouter>
              <Layout>
                <CustomerAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/"
          element={
            <Privaterouter>
              <Layout>
                {" "}
                <Dashboard />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/AddVehicleOwnerAccount"
          element={
            <Privaterouter>
              <Layout>
                <VehicleOwnerAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/VehicleAccount"
          element={
            <Privaterouter>
              <Layout>
                <VehicleAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/DriverAccount"
          element={
            <Privaterouter>
              <Layout>
                <DriverAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/VehicleOwnerAccount"
          element={
            <Privaterouter>
              <Layout>
                <VehicleOwnerAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/testfile"
          element={
            <Layout>
              <UploadForm />
            </Layout>
          }
        />
        <Route
          path="/BankAndCashAccount"
          element={
            <Privaterouter>
              <Layout>
                <BankAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/BankPayment"
          element={
            <Privaterouter>
              <Layout>
                <BankPayment />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/BankReceipt"
          element={
            <Privaterouter>
              <Layout>
                <BankReceipt />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/GeneralAccount"
          element={
            <Privaterouter>
              <Layout>
                <GeneralAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/NominalAccount"
          element={
            <Privaterouter>
              <Layout>
                <NominalAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CashPayment"
          element={
            <Privaterouter>
              <Layout>
                <CashPayment />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CashReceipt"
          element={
            <Privaterouter>
              <Layout>
                <CashReceipt />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/JournalVoucher"
          element={
            <Privaterouter>
              <Layout>
                <JournalVoucher />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/Contra"
          element={
            <Privaterouter>
              <Layout>
                <Contra />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/Ledger"
          element={
            <Privaterouter>
              <Layout>
                <Ledger />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="Ledger/:id/monthly"
          element={
            <Layout>
              <MonthlyAccountLedger />
            </Layout>
          }
        />
        <Route
          path="Ledger/:id/:MonthID"
          element={
            <Layout>
              <AccountVoucher />
            </Layout>
          }
        />
        <Route
          path="AccountGroup"
          element={
            <Privaterouter>
              <Layout>
                <AccountingGroup />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="StockGroup"
          element={
            <Privaterouter>
              <Layout>
                <StockGroup />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="StockItem"
          element={
            <Privaterouter>
              <Layout>
                <StockItem />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="UserRole"
          element={
            <Privaterouter>
              <Layout>
                <UserRole />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="UserEntry"
          element={
            <Privaterouter>
              <Layout>
                <UserEntry />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="orionappusers"
          element={
            <Privaterouter>
              <Layout>
                <OrionAppUsers />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="UserPageRights"
          element={
            <Privaterouter>
              <Layout>
                <UserRights />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="SingleAccountingCheck"
          element={
            <Privaterouter>
              <Layout>
                <SingleAccountCheck />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="PrintReportSetup"
          element={
            <Layout>
              <ReportSetup />
            </Layout>
          }
        />
        <Route
          path="LicenseeRights"
          element={
            <Layout>
              <LicenseRigths />
            </Layout>
          }
        />
        {/* <Route
          path="PaymentProcess"
          element={
            <Privaterouter>
              <Layout>
                <PaymentProcess />
              </Layout>
            </Privaterouter>
          }
        /> */}
        <Route
          path="LMSSalesBill"
          element={
            <Privaterouter>
              <Layout>
                <LMSSalesBill />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="TaxGroup"
          element={
            <Privaterouter>
              <Layout>
                <TaxGroup />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="Tax"
          element={
            <Privaterouter>
              <Layout>
                <Tax />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="HSNMaster"
          element={
            <Privaterouter>
              <Layout>
                <HSNMaster />
              </Layout>
            </Privaterouter>
          }
        />{" "}
        <Route
          path="LinkSaleExpense"
          element={
            <Privaterouter>
              <Layout>
                <LinkSaleExpenses />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="ReceiptInfo"
          element={
            <Privaterouter>
              <Layout>
                <ReceiptInfo />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="UtilityPage"
          element={
            <Privaterouter>
              <Layout>
                <UtilityPage />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="UserLogs"
          element={
            <Privaterouter>
              <Layout>
                <UserLogs />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ErrorLogs"
          element={
            // <Privaterouter>
            <Layout>
              <ErrorLogs />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="EmtUserLogs"
          element={
            <Privaterouter>
              <Layout>
                <EmtUserLogs />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="ErpUserLogs"
          element={
            <Privaterouter>
              <Layout>
                <ErpUserLogs />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="CustomerLogs"
          element={
            <Privaterouter>
              <Layout>
                <CustomerSideLogs />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="SideNavbar"
          element={
            <Privaterouter>
              <Layout>
                <SideNavBar />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="VoucherSeries"
          element={
            <Privaterouter>
              <Layout>
                <VoucherSeries />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="LiveUsers"
          element={
            <Privaterouter>
              <Layout>
                <LiveUsers />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="ReceivableBillByBill"
          element={
            <Privaterouter>
              <Layout>
                <ReceivableBillByBill />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="PayableBillByBill"
          element={
            <Privaterouter>
              <Layout>
                <PayableBillByBill />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path=":title/NewRef/:id"
          element={
            // <Privaterouter>
            <Layout>
              <NewReferences />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path=":title/NewRef/AgainstRef/:id"
          element={
            // <Privaterouter>
            <Layout>
              <AgainstReferences />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/RequestSupport"
          element={
            <Privaterouter>
              <Layout>
                <RequestSupport />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/RequestSupport/ClosedIsues"
          element={
            <Privaterouter>
              <Layout>
                <ClosedIssues />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/RequestSupport/HoldIssues"
          element={
            <Privaterouter>
              <Layout>
                <HoldIssues />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/RequestSupport/OpenIssues"
          element={
            <Privaterouter>
              <Layout>
                <OpenIssues />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/RequestSupport/UnReadIssues"
          element={
            <Privaterouter>
              <Layout>
                <UnReadIssues />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/RequestSupport/ticket/:id"
          element={
            // <Privaterouter>
            <Layout>
              <SingleIssue />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/AdminRequestSupport"
          element={
            <Privaterouter>
              <Layout>
                <AdminRequestSupport />
              </Layout>
            </Privaterouter>
          }
        />
        <Route path="/file/:imageUrl/*" element={<ViewImage />} />
        <Route
          path="/BookingPage"
          element={
            // <Privaterouter>
            <Layout>
              <BookingPage />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/Claims"
          element={
            <Privaterouter>
              <Layout>
                <ClaimsPage />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/RequestApproval"
          element={
            <Privaterouter>
              <Layout>
                <RequestApproval />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ConsignmentNote"
          element={
            <Privaterouter>
              <Layout>
                <ConsignmentNote />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/FTLConsignmentNote"
          element={
            <Privaterouter>
              <Layout>
                <FTLConsignmentNote />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PageMaster"
          element={
            <Privaterouter>
              <Layout>
                <PageMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/LicenseeMaster"
          element={
            <Privaterouter>
              <Layout>
                <License />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CompanyMaster"
          element={
            <Privaterouter>
              <Layout>
                <Company />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/BranchMaster"
          element={
            <Privaterouter>
              <Layout>
                <Branch />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/MenuMaster"
          element={
            <Privaterouter>
              <Layout>
                <MenuMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/SubMenuMaster"
          element={
            <Privaterouter>
              <Layout>
                <SubMenuMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/AutoTransactionMaster"
          element={
            <Privaterouter>
              <Layout>
                <ChargeMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/EventMaster"
          element={
            <Privaterouter>
              <Layout>
                <EventMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/VehicleTypeMaster"
          element={
            <Privaterouter>
              <Layout>
                <VehicleTypeMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/VehicleCategoryMaster"
          element={
            <Privaterouter>
              <Layout>
                <VehicleCategoryMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/VehicleLengthMaster"
          element={
            <Privaterouter>
              <Layout>
                <VehicleLength />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ModelTypeMaster"
          element={
            <Privaterouter>
              <Layout>
                <ModalTypeMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CreditNote"
          element={
            <Privaterouter>
              <Layout>
                <CreditNote />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/POD"
          element={
            <Privaterouter>
              <Layout>
                <POD />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PaymentProcess"
          element={
            <Privaterouter>
              <Layout>
                <Payment />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/DebitNote"
          element={
            // <Privaterouter>
            <Layout>
              <DebitNote />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/InwardConnectionCenter"
          element={
            <Privaterouter>
              <Layout>
                <InwardConnectionCenter />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ConnectionMemoUpdation"
          element={
            <Privaterouter>
              <Layout>
                <ConnectionStatusUpdate />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/WarehouseMaster"
          element={
            <Privaterouter>
              <Layout>
                <WarehouseMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PickupMemo"
          element={
            <Privaterouter>
              <Layout>
                <PickUpMemo />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/DeliveryMemo"
          element={
            <Privaterouter>
              <Layout>
                <DeliveryPlanning />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ConnectionMemoReceive"
          element={
            <Privaterouter>
              <Layout>
                <DestinationInward />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/LRDelivery"
          element={
            <Privaterouter>
              <Layout>
                <DeliveryConfirmation />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CNPickupUpdation"
          element={
            <Privaterouter>
              <Layout>
                <CNPickupUpdation />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ConnectionMemo"
          element={
            <Privaterouter>
              <Layout>
                <ConnectionPlanning />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/AlertTemplate"
          element={
            // <Privaterouter>
            <Layout>
              <AlertTemplate />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/AlertManagement"
          element={
            // <Privaterouter>
            <Layout>
              <AlertManagemenet />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/PurchaseBill"
          element={
            <Privaterouter>
              <Layout>
                <PurchaseBill />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CSUsers"
          element={
            <Privaterouter>
              <Layout>
                <CSUsers />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/AssetAccount"
          element={
            <Privaterouter>
              <Layout>
                <AssetAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ProductMaster"
          element={
            // <Privaterouter>
            <Layout>
              <ProductMaster />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/FieldsMaster"
          element={
            <Privaterouter>
              <Layout>
                <FieldsMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PaymentTermsMaster"
          element={
            <Privaterouter>
              <Layout>
                <PaymentTermsMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/UserPaymentTermsManagement"
          element={
            <Privaterouter>
              <Layout>
                <UserPaymentTermsManagement />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/LRTypeMaster"
          element={
            <Privaterouter>
              <Layout>
                <LRTypeMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CityMaster"
          element={
            <Privaterouter>
              <Layout>
                <Cityes />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/StateMaster"
          element={
            <Privaterouter>
              <Layout>
                <States />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/AreaMaster"
          element={
            <Privaterouter>
              <Layout>
                <AreaMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CountryMaster"
          element={
            <Privaterouter>
              <Layout>
                <CountryMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/GodownMaster"
          element={
            <Privaterouter>
              <Layout>
                <GodownMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/DistrictMaster"
          element={
            <Privaterouter>
              <Layout>
                <DistrictMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ZoneMaster"
          element={
            <Privaterouter>
              <Layout>
                <ZoneMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PincodeMaster"
          element={
            <Privaterouter>
              <Layout>
                <PinCodeMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/VehicleManagement"
          element={
            // <Privaterouter>
            <Layout>
              <VehicleManagement />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/THC"
          element={
            <Privaterouter>
              <Layout>
                <THC />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/FTLCNDelivery"
          element={
            <Privaterouter>
              <Layout>
                <FTLCNDelivery />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/FreightBill"
          element={
            <Privaterouter>
              <Layout>
                <FreightBill />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/FreightBill"
          element={
            <Privaterouter>
              <Layout>
                <CustomerSideLogs />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PincodeMaster"
          element={
            <Privaterouter>
              <Layout>
                <PinCodeMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/MaterialCategory"
          element={
            <Privaterouter>
              <Layout>
                <MaterialCategory />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/BalanceSheet"
          element={
            <Privaterouter>
              <Layout>
                <BalanceSheet />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/Profit&Loss"
          element={
            <Privaterouter>
              <Layout>
                <ProfitAndLoss />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/EmtMarketRates"
          element={
            <Privaterouter>
              <Layout>
                <EmtMarketRate />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/Myloads"
          element={
            // <Privaterouter>
            <Layout>
              <LoadBoard />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/Shipment_Tracking"
          element={
            <Privaterouter>
              <Layout>
                <ShipmentTrackBoard />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/EmtAccounts"
          element={
            <Privaterouter>
              <Layout>
                <EmtAccounts />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/Myshipments"
          element={
            // <Privaterouter>
            <Layout>
              <MyShipment />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/MyShipmentTracking"
          element={
            <Privaterouter>
              <Layout>
                <MyShipmentTracking />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PrivateNetwork"
          element={
            <Privaterouter>
              <Layout>
                <PrivateNetwork />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PrivateGroup"
          element={
            <Privaterouter>
              <Layout>
                <PrivateGroup />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/FinancialYear"
          element={
            <Privaterouter>
              <Layout>
                <NewFinancialYear />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ConnectionCenter"
          element={
            <Privaterouter>
              <Layout>
                <ConnectionCenter />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/FlightMaster"
          element={
            <Privaterouter>
              <Layout>
                <FlightMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TruckPost"
          element={
            <Privaterouter>
              <Layout>
                <TruckPost />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/MyTruckPost"
          element={
            <Privaterouter>
              <Layout>
                <MyTruckPost />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/MyVehicleManagement"
          element={
            <Privaterouter>
              <Layout>
                <MyVehicleManagement />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ConsignorPart"
          element={
            <Layout>
              <ConsignorPart />
            </Layout>
          }
        />
        <Route
          path="/PackagingMaster"
          element={
            <Privaterouter>
              <Layout>
                <PackagingMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PartMaster"
          element={
            <Privaterouter>
              <Layout>
                <PartMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ServiceTypeMaster"
          element={
            <Privaterouter>
              <Layout>
                <ServiceTypeMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ContactPersonMaster"
          element={
            <Privaterouter>
              <Layout>
                <ContactPersonMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/StatusBoard"
          element={
            <Layout>
              <StatusBoard />
            </Layout>
          }
        />
        <Route
          path="/StatusBoard/:id"
          element={
            <Layout>
              <Board />
            </Layout>
          }
        />
        <Route
          path="/SalesBill"
          element={
            <Layout>
              <SalesBill />
            </Layout>
          }
        />
        <Route
          path="/ERPAddressBookMaster"
          element={
            <Privaterouter>
              <Layout>
                <ERPAddressBookMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/LrBook"
          element={
            <Privaterouter>
              <Layout>
                <LrBook />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/LrCenter"
          element={
            <Privaterouter>
              <Layout>
                <LrCenter />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TableColumnManagement"
          element={
            <Privaterouter>
              <Layout>
                <TableColumnManagement />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TableKey"
          element={
            <Privaterouter>
              <Layout>
                <TableKey />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/FormKeys"
          element={
            <Privaterouter>
              <Layout>
                <FormKeyMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TrainMaster"
          element={
            <Privaterouter>
              <Layout>
                <TrainMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/VesselMaster"
          element={
            <Privaterouter>
              <Layout>
                <VesselMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/EMTDriverAccount"
          element={
            <Privaterouter>
              <Layout>
                <EMTDriverAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TaxPercentage"
          element={
            // <Privaterouter>
            <Layout>
              <Tax_Percentage />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/PlaceMaster"
          element={
            <Privaterouter>
              <Layout>
                <PlaceMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/LMSProcess"
          element={
            <Privaterouter>
              <Layout>
                <LMSProcess />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="TableFieldMaster"
          element={
            <Privaterouter>
              <Layout>
                <AddFieldMaster />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="Invoice"
          element={
            // <Privaterouter>
            <Layout>
              <InvoiceFormat />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/EmtLoadDetails"
          element={
            <Privaterouter>
              <Layout>
                <EmtLoadDetails />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/LoadPostDetails"
          element={
            <Privaterouter>
              <Layout>
                <LoadPostDetails />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/LoadPostErp"
          element={
            <Privaterouter>
              <Layout>
                <LoadPostErp />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/AccLoadPost"
          element={
            <Privaterouter>
              <Layout>
                <AccLoadPost />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TruckPostDetails"
          element={
            <Privaterouter>
              <Layout>
                <TruckPostDetails />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/AppDetails"
          element={
            <Privaterouter>
              <Layout>
                <AppDetails />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PageActivityDetails"
          element={
            <Privaterouter>
              <Layout>
                <PageActivityDetails />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TrackDetails"
          element={
            <Privaterouter>
              <Layout>
                <TrackDetails />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ClaimSales"
          element={
            <Privaterouter>
              <Layout>
                <ClaimSales />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ClaimSale"
          element={
            // <Privaterouter>
            <Layout>
              <AddClaimSale />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/KYCVerification"
          element={
            // <Privaterouter>
            <Layout>
              <AddKYCVerification />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/KYCVerifications"
          element={
            <Privaterouter>
              <Layout>
                <KYCVerification />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/References"
          element={
            <Privaterouter>
              <Layout>
                <AllReferences />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/EmtReports"
          element={
            <Privaterouter>
              <Layout>
                <EmtReports />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/BookingBroker"
          element={
            <Privaterouter>
              <Layout>
                <BookingBroker />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/EmployeeAccount"
          element={
            <Privaterouter>
              <Layout>
                <EmployeeAccount />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/Tax"
          element={
            // <Privaterouter>
            <Layout>
              <Taxes />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/EmtReports"
          element={
            <Privaterouter>
              <Layout>
                <EmtReports />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TMSTruckPost"
          element={
            <Privaterouter>
              <Layout>
                <TMSTruckPost />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/Todo"
          element={
            // <Privaterouter>
            <Layout>
              <Todo />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/LoadBoard"
          element={
            <Privaterouter>
              <Layout>
                <TMSLoadBoard />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TollAndFuelCalculator"
          element={
            <Privaterouter>
              <Layout>
                <AddTollAndFuelCalculator />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PaymentGateway"
          element={
            <Privaterouter>
              <Layout>
                <PaymentGateway />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/FormFields"
          element={
            <Privaterouter>
              <Layout>
                <InputFields />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/FormSection"
          element={
            <Privaterouter>
              <Layout>
                <FormSections />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/Folder"
          element={
            <Privaterouter>
              <Layout>
                <Folder />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/StockReport"
          element={
            <Privaterouter>
              <Layout>
                <StockReport />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CNLocationReport"
          element={
            <Privaterouter>
              <Layout>
                <CNLocationReport />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/SalesReturn"
          element={
            <Privaterouter>
              <Layout>
                <SalesReturn />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/EmtVideoTutorial"
          element={
            <Privaterouter>
              <Layout>
                <EmtVideoTutorial />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/ConsignmentNoteRagister"
          element={
            <Privaterouter>
              <Layout>
                <ConsignmentNoteRagister />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CompliancesMaster"
          element={
            <Privaterouter>
              <Layout>
                <Compliances />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TradingReport"
          element={
            <Privaterouter>
              <Layout>
                <TradingReport />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PrintLayout"
          element={
            // <Privaterouter>
            <Layout>
              <PrintLayout />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/OperationsManagement"
          element={
            // <Privaterouter>
            <Layout>
              <OperationsManagement />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/AccountingChecks"
          element={
            <Privaterouter>
              <Layout>
                <AccountChecks />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/MonthlyAccountBalanceChecks"
          element={
            <Privaterouter>
              <Layout>
                <MonthlyAccountBalanceCheck />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/AccountingChecksPage"
          element={
            <Privaterouter>
              <Layout>
                <AccountingChecksPage />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/EmtPlans"
          element={
            <Privaterouter>
              <Layout>
                <EmtPlans />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TrailOpeningBalances"
          element={
            <Privaterouter>
              <Layout>
                <TrailOpeningBalances />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TrailBalance"
          element={
            <Privaterouter>
              <Layout>
                <TrailBalance />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TransactionsCheck"
          element={
            <Privaterouter>
              <Layout>
                <TransactionsCheck />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/CallReport"
          element={
            <Privaterouter>
              <Layout>
                <CallReport />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/TCS"
          element={
            // <Privaterouter>
            <Layout>
              <TCS />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/TDS"
          element={
            // <Privaterouter>
            <Layout>
              <TDS />
            </Layout>
            // </Privaterouter>
          }
        />
        <Route
          path="/salesItemReport"
          element={
            <Privaterouter>
              <Layout>
                <StockItemSalesReportForSalesBill />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/purchaseItemReport"
          element={
            <Privaterouter>
              <Layout>
                <StockItemSalesReportForPurchaseBill />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/salesItemReport/:id"
          element={
            <Layout>
              <SalesReportVoucherEntries />
            </Layout>
          }
        />
        <Route
          path="/purchaseItemReport/:id"
          element={
            <Layout>
              <SalesReportVoucherEntries />
            </Layout>
          }
        />
        <Route
          path="/PriceLists"
          element={
            <Privaterouter>
              <Layout>
                <PriceList />
              </Layout>
            </Privaterouter>
          }
        />
        <Route
          path="/PendingBillForLR"
          element={
            <Privaterouter>
              <Layout>
                <PendingBillForLR />
              </Layout>
            </Privaterouter>
          }
        />
        <Route path="/file/:imageUrl/*" element={<ViewImage />} />
      </Routes>
    </>
  );
};
export default AllRoutes;
